import { I18n } from 'aws-amplify/utils'

import {
  COGNITO_PASSWORD_MESSAGES,
  CUSTOM_ERROR_MESSAGES,
  PASSWORD_MIN_LENGTH_MESSAGE,
} from 'ui/screens/SignIn/consts'

/**
 * Replaces raw Cognito password errors with our own copy.
 *
 * The Authenticator renders every remote error through `I18n.get`, so this is the
 * only interception point that covers all auth routes. It is the sole option for
 * the forceNewPassword flow, which submits via an internal service that the
 * Authenticator's `services` prop cannot override.
 */
export const configureAmplifyI18n = () => {
  /* I18n otherwise resolves the language from the browser, which would miss these
   * entries for non-English locales. All Authenticator copy is English regardless,
   * since the Amplify translation dictionaries are never loaded.
   */
  I18n.setLanguage('en')

  I18n.putVocabulariesForLanguage('en', {
    [COGNITO_PASSWORD_MESSAGES.compromised]:
      CUSTOM_ERROR_MESSAGES.compromisedPassword,
    [COGNITO_PASSWORD_MESSAGES.notLongEnough]: PASSWORD_MIN_LENGTH_MESSAGE,
    [COGNITO_PASSWORD_MESSAGES.notLongEnoughLegacy]:
      PASSWORD_MIN_LENGTH_MESSAGE,
  })
}
